module.exports = __webpack_public_path__ + "img/icon-folder.8fc5c020.svg";